import trace from '~/lib/trace';
import React, {useEffect, useState} from 'react';
import {View} from 'react-native';

import DirectionsCarIcon from '~/images/md-icons/directions_car/materialicons/24px.svg';
import PropTypes from 'prop-types';

const CarPersona = ({brand, size = 40}) => {
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const retrieve = async () => {
      const image_url = `https://bahnkick.blob.core.windows.net/company-logos/${brand?.replaceAll(
        '/',
        ':',
      )}.svg`;
      setImage(image_url);
      setLoading(true);
    };

    retrieve().catch(trace);
  }, [brand]);

  const height = size;
  const width = size;

  return (
    <View
      style={{
        overflow: 'hidden',
        width,
        height,
        visibility: loading ? 'hidden' : 'visible',
      }}>
      {image ? (
        <img
          src={image}
          style={{width, height}}
          alt={brand}
          onLoad={() => {
            setLoading(false);
          }}
          onError={() => {
            setImage(null);
            setLoading(false);
          }}
        />
      ) : (
        <DirectionsCarIcon fill="#4A4A49" style={{width, height}} />
      )}
    </View>
  );
};
CarPersona.propTypes = {
  brand: PropTypes.any,
  size: PropTypes.any,
};

export default CarPersona;
